import { useActionHandler, useKeyboard, useWorkspaceAutosave } from "@/hooks";
import { Flex } from "@mantine/core";
import { WorkspaceContent } from "./content/WorkspaceContent";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import { WorkspaceHeader } from "./header/WorkspaceHeader";
import { WorkspaceSidebar } from "./sidebar/WorkspaceSidebar";
import "./Workspace.css";

export function Workspace({
  dataflowId,
  projectId,
}: {
  dataflowId?: string;
  projectId?: string;
} = {}) {
  const actionHandler = useActionHandler();
  /* @deprecated
  const { dataflowId, projectId } = useWorkspaceIds(
    propDataflowId,
    propProjectId
  );
  */
  /* @deprecated
  const dataflow = useDataflowStore((state) =>
    dataflowId ? state.dataflows[dataflowId] : undefined
  );
  */

  useWorkspaceAutosave({
    dataflowId,
    projectId,
  });

  useKeyboard({
    id: "paste",
    keys: ["ctrl+v", "meta+v"],
    onKeyPressed: actionHandler,
  });

  return (
    <WorkspaceProvider dataflowId={dataflowId} projectId={projectId}>
      <Flex className="workspace-container">
        <WorkspaceHeader />
        <Flex className="workspace-layout">
          <WorkspaceContent />
          <WorkspaceSidebar />
        </Flex>
      </Flex>
    </WorkspaceProvider>
  );
}
